import React, { createContext, useState, useMemo, useEffect } from 'react';

import { SigningErrors } from '../components/ErrorModal/ErrorModal';

interface ErrorContextInterface {
    setError: React.Dispatch<React.SetStateAction<SigningErrors | null>>;
    error: SigningErrors | null;
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}
export const ErrorContext = createContext<ErrorContextInterface | undefined>(undefined);

export const useErrorContext = () => {
    const context = React.useContext(ErrorContext);
    if (context === undefined) {
        throw new Error('useErrorContext must be used within a ErrorProvider');
    }
    return context;
};

export const ErrorProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [error, setError] = useState<SigningErrors | null>(null);
    const [showModal, setShowModal] = useState<boolean>(false);

    useEffect(() => {
        if (error) setShowModal(true);
    }, [error]);

    const value = useMemo(
        () => ({ error, setError, showModal, setShowModal }),
        [error, setError, showModal, setShowModal],
    );

    return <ErrorContext.Provider value={value}>{children}</ErrorContext.Provider>;
};
